var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeadHeart = function SvgHeadHeart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M2 9.006C2 5.144 5.131 2 9 2h.75c2.975 0 5.663 2.166 6.166 5.006.072.406.212.803.471 1.125L17.7 9.775A1.368 1.368 0 0 1 16.631 12H16v2c0 1.103-.897 2-2 2h-2v1c0 .553-.447 1-1 1H5c-.553 0-1-.447-1-1v-2.272c0-.522-.216-1.015-.534-1.431A7 7 0 0 1 2 9.007m3.5-1.094c0 .507.203.994.56 1.354l2.584 2.584a.5.5 0 0 0 .706 0l2.584-2.584a1.916 1.916 0 0 0-2.71-2.71l-.23.231-.232-.23a1.916 1.916 0 0 0-3.269 1.356z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeadHeart);
export default ForwardRef;